import { render, staticRenderFns } from "./OutKuDetail.vue?vue&type=template&id=dbc44044&scoped=true&"
import script from "./OutKuDetail.vue?vue&type=script&lang=js&"
export * from "./OutKuDetail.vue?vue&type=script&lang=js&"
import style0 from "./OutKuDetail.vue?vue&type=style&index=0&id=dbc44044&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc44044",
  null
  
)

export default component.exports